var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-navigation" }, [
    _c("div", { staticClass: "mobile-navigation__wrapper" }, [
      _c("div", { staticClass: "mobile-navigation__header-wrapper" }, [
        _c(
          "button",
          {
            staticClass: "mobile-navigation__close",
            on: {
              click: function ($event) {
                return _vm.closeNavigation()
              },
            },
          },
          [
            _c("svg", { attrs: { width: "20", height: "20" } }, [
              _c("use", {
                attrs: {
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  "xlink:href": "#svg-close",
                },
              }),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            directives: [
              { name: "close-mobile-search", rawName: "v-close-mobile-search" },
            ],
            staticClass: "mobile-navigation__close-search",
          },
          [
            _c("svg", { attrs: { width: "44", height: "20" } }, [
              _c("use", {
                attrs: {
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  "xlink:href": "#svg-arrow-back-long",
                },
              }),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mobile-navigation__search-wrapper" },
          [_c("item-search", { attrs: { type: "mobile" } })],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mobile-navigation__content-wrapper" }, [
        _c("div", { staticClass: "mobile-navigation__tabs-wrapper" }, [
          _c(
            "ul",
            {
              staticClass: "mobile-navigation__tab-list",
              attrs: { id: "mobile-tab-menu", role: "menu" },
            },
            _vm._l(_vm.dataContainer1, function (category) {
              return _vm.showCategorie(category.id)
                ? _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !category.hideCategory,
                          expression: "!category.hideCategory",
                        },
                      ],
                      staticClass: "mobile-navigation__tab-item",
                      class: {
                        "mobile-navigation__tab-item--active":
                          _vm.parent.id === category.id,
                      },
                      attrs: { role: "menuitem" },
                      on: {
                        click: function ($event) {
                          return _vm.slideTo(
                            category.children,
                            category.id,
                            category
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(category.details[0].name) +
                          "\n                    "
                      ),
                    ]
                  )
                : _vm._e()
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mobile-navigation__menu-wrapper" }, [
          _c(
            "ul",
            {
              staticClass: "mobile-navigation__menu-list",
              attrs: { id: "mobile-menu-list", role: "menu" },
            },
            [
              typeof _vm.parent.details !== "undefined" &&
              typeof _vm.parent.details[0] !== "undefined" &&
              typeof _vm.customLinks[_vm.parent.id] === "undefined"
                ? _c(
                    "li",
                    {
                      staticClass: "mobile-navigation__menu-all",
                      attrs: { role: "menuitem" },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "mobile-navigation__menu-all-link",
                          attrs: {
                            href: _vm.getCategoryUrl(_vm.parent.url),
                            title: _vm.parent.details[0].name,
                            "data-to-all": "true",
                            id: "heading-" + _vm.parent.id,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.closeNavigation()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$translate(
                                  "ODFashioncode::Fashioncode.toAllCategoriesMobile"
                                )
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              typeof _vm.parent.details !== "undefined" &&
              typeof _vm.parent.details[0] !== "undefined" &&
              typeof _vm.customLinks[_vm.parent.id] !== "undefined"
                ? _c(
                    "li",
                    {
                      staticClass: "mobile-navigation__menu-all",
                      attrs: { role: "menuitem" },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "mobile-navigation__menu-all-link",
                          attrs: {
                            href: _vm.customLinks[_vm.parent.id],
                            title: _vm.parent.details[0].name,
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$translate(
                                  "ODFashioncode::Fashioncode.toAllCategoriesMobile"
                                )
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer2, function (category) {
                return category.showChildren ||
                  typeof category.details[0] !== "undefined"
                  ? _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !category.hideCategory,
                            expression: "!category.hideCategory",
                          },
                        ],
                        staticClass: "mobile-navigation__menu-item",
                        attrs: { role: "menuitem" },
                      },
                      [
                        _vm.getReplace(category)
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "mobile-navigation__menu-link",
                                  attrs: {
                                    href: _vm.getReplace(category).url,
                                    title:
                                      _vm.getReplace(category).details[0].name,
                                    id:
                                      "heading-" + _vm.getReplace(category).id,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.closeNavigation()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.getReplace(category).details[0].name
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ]
                          : [
                              _c(
                                "a",
                                {
                                  staticClass: "mobile-navigation__menu-link",
                                  attrs: {
                                    href: _vm.getCategoryUrl(category.url),
                                    title: category.details[0].name,
                                    id: "heading-" + category.id,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.closeNavigation()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(category.details[0].name) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ],
                      ],
                      2
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              typeof _vm.saleLinks !== "undefined"
                ? [
                    _vm.saleLinks[_vm.parent.id] &&
                    typeof _vm.saleLinks[_vm.parent.id] !== "undefined" &&
                    _vm.saleNewActive["sale"].includes(_vm.parent.id)
                      ? _c(
                          "li",
                          {
                            staticClass: "mobile-navigation__menu-item",
                            attrs: { role: "menuitem" },
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "mobile-navigation__menu-link mobile-navigation__menu-link--sale",
                                attrs: {
                                  href:
                                    _vm.getCategoryUrl(_vm.parent.url) +
                                    "/sale",
                                  title:
                                    _vm.parent.details[0].name +
                                    _vm.$translate(
                                      "ODFashioncode::Fashioncode.headerSale"
                                    ),
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$translate(
                                        "ODFashioncode::Fashioncode.headerSale"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._v(" "),
              typeof _vm.newLinks !== "undefined"
                ? [
                    _vm.newLinks[_vm.parent.id] &&
                    typeof _vm.newLinks[_vm.parent.id] !== "undefined" &&
                    _vm.saleNewActive["new"].includes(_vm.parent.id)
                      ? _c(
                          "li",
                          {
                            staticClass: "mobile-navigation__menu-item",
                            attrs: { role: "menuitem" },
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "mobile-navigation__menu-link mobile-navigation__menu-link--new",
                                attrs: {
                                  href:
                                    _vm.getCategoryUrl(_vm.parent.url) + "/new",
                                  title:
                                    _vm.parent.details[0].name +
                                    _vm.$translate(
                                      "ODFashioncode::Fashioncode.headerNew"
                                    ),
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$translate(
                                        "ODFashioncode::Fashioncode.headerNew"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }